import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { DragIndicator } from "@material-ui/icons";

import { getClausesByContractTypeFormat } from "../../actions/contract-type-actions";
import { useStateValue } from "../../context/store";
import { numeroOrdinal } from "./models";
import utils from "../../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    //flexGrow: 1,
    "&::-webkit-scrollbar": {
      width: 15,
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.1)`,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#BAE5F9",
      outline: `1px solid #ffffff`,
      borderRadius: 10,
    },
  },
}));

export default function FormatClauses({
  contractTypeId,
  setClausesByContractType,
  hasChangesClauses,
  setHasChangesOrderClauses,
}) {
  const [{}, dispatch] = useStateValue();
  const classes = useStyles();
  const [clausesByContractTypeLocal, setClausesByContractTypeLocal] = useState(
    []
  );

  const getClauses = async () => {
    const clauses = await getClausesByContractTypeFormat(
      contractTypeId,
      dispatch
    );
    setClausesByContractTypeLocal(clauses.data.clauses);
    setTimeout(() => {
      let orderFavorite = clauses?.data?.clauses?.map((clause, index) => {
        clause.order = index + 1;
        clause.tipoContrato = true;

        clause.ordinal = numeroOrdinal[index].toUpperCase();
        return clause;
      });

      setClausesByContractType(orderFavorite);
    }, 100);
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configurar Formato de contrato",
      breadCrumbSubText: "Configurar Formato de contrato",
      index: 16,
      handleSaveOrderClauses: false,
    });
  }, []);

  useEffect(() => {
    getClauses();
  }, [hasChangesClauses]);

  const onSortEnd = (oldIndex, newIndex) => {
    setHasChangesOrderClauses(true);
    let changeOrder = arrayMove(clausesByContractTypeLocal, oldIndex, newIndex);

    setClausesByContractTypeLocal((array) =>
      arrayMove(array, oldIndex, newIndex)
    );
    setTimeout(() => {
      let orderFavorite = changeOrder.map((clause, index) => {
        clause.order = index + 1;
        clause.tipoContrato = true;
        clause.ordinal = numeroOrdinal[index].toUpperCase();
        return clause;
      });

      setClausesByContractType(orderFavorite);
    }, 100);
  };

  return (
    <div
      style={{ maxHeight: "700px", overflow: "auto" }}
      className={classes.root}
    >
      <SortableList
        onSortEnd={onSortEnd}
        className="lista"
        draggedItemClassName="dragged"
      >
        {clausesByContractTypeLocal?.map((modelo, index) => (
          <SortableItem key={modelo.id}>
            <Grid
              container
              spacing={3}
              style={{
                maxWidth: "90%",
                margin: "0px",
                minHeight: "150px",
                marginBottom: "20px",
                backgroundColor: "#BFE0E7",
                borderRadius: "5px",
              }}
            >
              <Grid
                item
                xs={2}
                style={{
                  maxWidth: "10px",
                  paddingTop: "35px",
                  paddingRight: "30px",
                }}
              >
                <DragIndicator
                  style={{
                    cursor: "grab",
                    fontSize: "30px",
                    marginTop: "24px",
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <Typography style={{ fontWeight: "bold" }}>
                  {modelo.ordinal + ": " + modelo.name}
                </Typography>
                <Typography style={{ fonstSize: "12px" }}>
                  {utils.replaceTextDynamicClauses(
                    modelo.definitionClause.length > 235
                      ? modelo.definitionClause.substr(0, 235) + " ..."
                      : modelo.definitionClause
                  )}
                </Typography>
              </Grid>
            </Grid>
          </SortableItem>
        ))}
      </SortableList>
    </div>
  );
}
